import script from "./VNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./VNotification.vue?vue&type=script&setup=true&lang=js"

import "./VNotification.vue?vue&type=style&index=0&id=589c0ea0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589c0ea0"]])

export default __exports__